import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: `'Open Sans', sans-serif`,
  },
  palette: {
    primary: {
      main: '#065C4C',         // Color de logo
      dark: '#0A826C',         // Títulos
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#16B194',         // Detalles (secundario)
      contrastText: '#ffffff',
    },
    info: {
      main: '#16B194',         // También puedes usarlo para badges, iconos
    },
    text: {
      primary: '#273038',      // Color del cuerpo de texto
      secondary: '#565E64',    // Puedes agregar uno más claro para subtítulos
    },
    background: {
      default: '#F4F4F4',
      paper: '#ffffff',
    },
  },
});

export default theme;
